import { createFileRoute } from '@tanstack/react-router'
import { InsightFindings } from '@/features/insights/findings'

type FindingsSearch = {
  severity?: 'all' | 'critical' | 'warning' | 'info'
  state?: 'all' | 'open' | 'resolved'
  check?: string
  window?: '24h' | '7d' | '30d' | 'all'
  ownerUserId?: number
  triage?:
    | 'untriaged'
    | 'acknowledged'
    | 'in_progress'
    | 'accepted_risk'
    | 'false_positive'
  overdue?: boolean
}

const findingStates = [
  'untriaged',
  'acknowledged',
  'in_progress',
  'accepted_risk',
  'false_positive',
] as const

const parseSearch = (search: Record<string, unknown>): FindingsSearch => {
  const ownerUserId = Number(search.ownerUserId)
  return {
    severity:
      search.severity === 'all' ||
      search.severity === 'critical' ||
      search.severity === 'warning' ||
      search.severity === 'info'
        ? search.severity
        : undefined,
    state:
      search.state === 'open' || search.state === 'resolved'
        ? search.state
        : undefined,
    check: typeof search.check === 'string' ? search.check : undefined,
    window:
      search.window === '24h' ||
      search.window === '7d' ||
      search.window === '30d' ||
      search.window === 'all'
        ? search.window
        : undefined,
    ownerUserId:
      Number.isInteger(ownerUserId) && ownerUserId > 0
        ? ownerUserId
        : undefined,
    triage: findingStates.find((state) => state === search.triage),
    overdue: search.overdue === true ? true : undefined,
  }
}

export const Route = createFileRoute(
  '/_authenticated/instances/$instanceId/findings'
)({
  validateSearch: parseSearch,
  component: InsightFindings,
})
